import { api_request } from '../axios_client';
import { handleError } from '../common';
import * as Constants from '../constants';

const isSI = true;
const v1SiSoSkuValidatePost = async (soId, file, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.validateSKU}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: { soId },
      data: { file },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiEoSkuValidatePost = async (soId, file, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_eo}/${soId}${Constants.PATH.SALES.SALES_ORDER.eoValidateSKU}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data: { file },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoSkuSubmitPost = async (soId, fileId, buyerPoFile, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_so}/${soId}${Constants.PATH.SALES.SALES_ORDER.submitSKU}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: { soId, fileId },
      data: { buyerPoFile },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoCreateManualPost = async (data, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.manualSOCreation}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoCreatePost = async (poId, fileId, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.createSO}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: { poId, fileId },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoDeleteSkuPut = async (soId, fileId, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.deleteSKU}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      params: { soId, fileId },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoUploadReceiptsPut = async (
  soId,
  receiptDate,
  receiptType,
  receiptNumber,
  data,
  is_mensa_responsible_for_delivery,
  options
) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.uploadReceipts}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      params: {
        soId,
        receiptDate,
        receiptType,
        receiptNumber,
        is_mensa_responsible_for_delivery
      },
      data,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoCancelPut = async (data, soId, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.cancelSO}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      params: { soId },
      data,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoEditPut = async (data, soId, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.edit}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      params: { soId },
      data,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoOptionsGet = async (so_type, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.options}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { so_type },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoDetailsGet = async (soId, view, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.details}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { soId, view },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoDownloadSkuListGet = async (soId, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.downloadSKUList}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { soId },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoListGet = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.list}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: options,
      signal,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiEoListGet = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.eoList}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: options,
      signal,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoSummaryGet = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.summary}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: options,
      signal,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiEoSummaryGet = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.eoSummary}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: options,
      signal,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoFiltersGet = async (signal, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.filters}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      signal,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoEoFiltersGet = async (signal, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.eoFilters}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      signal,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoPackValidatePost = async (soId, file, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.validateSOPack}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: { soId },
      data: { file },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoPackingDetailsValidatePost = async (soId, file, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.packingDetailsValidate}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: { soId },
      data: { file },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoPackSubmitPost = async (soId, fileId, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.submitPack}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: { soId, fileId },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoPackingDetailsSubmitPost = async (soId, fileId, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.packingDetailsSubmit}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: { soId, fileId },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoPackSampleGet = async (invoiceType, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.samplePack}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { invoice_type: invoiceType },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoPackingDetailsSampleGet = async (invoiceType, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.packingDetailsSample}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { invoice_type: invoiceType },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoGenerateProformaInvoiceGet = async (soId, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.generateProformaInvoice}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { soId },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoInventoryValidationPost = async (soId, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_so}/${soId}${Constants.PATH.SALES.SALES_ORDER.inventoryValidation}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoMarkAsOpenPost = async (soId, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.markAsOpen}/${soId}${Constants.PATH.SALES.SALES_ORDER.generateCsv}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: {},
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoSampleGet = async (invoice_type, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.sample}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { invoice_type },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoClearTaxTaxInvoicePreGeneratePost = async (id, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.clearTaxTaxInvoicePreGenerate}?soId=${id}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoAddAppointmentPost = async (id, data, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_so}/${id}${Constants.PATH.SALES.SALES_ORDER.addAppointment}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      options,
      isSI,
      data
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoEditAppointmentPost = async (id, data, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_so}/${id}${Constants.PATH.SALES.SALES_ORDER.editAppointment}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      options,
      isSI,
      data
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoUploadEpodPost = async (id, data, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_so}/${id}${Constants.PATH.SALES.SALES_ORDER.uploadEpod}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      options,
      isSI,
      data
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoEpodManualUploadPost = async (id, data, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_so}/${id}${Constants.PATH.SALES.SALES_ORDER.epodManualUpload}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      options,
      isSI,
      data
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoEpodCancelPut = async (id, data, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_so}/${id}${Constants.PATH.SALES.SALES_ORDER.epodCancel}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      options,
      isSI,
      data
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoCancelAppointmentPost = async (id, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_so}/${id}${Constants.PATH.SALES.SALES_ORDER.cancelAppointment}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiEoAddAppointmentPost = async (id, data, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_eo}/${id}${Constants.PATH.SALES.SALES_ORDER.addAppointment}`;
  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      options,
      isSI,
      data
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiEoEditAppointmentPost = async (id, data, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_eo}/${id}${Constants.PATH.SALES.SALES_ORDER.editAppointment}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      options,
      isSI,
      data
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiEoCancelAppointmentPost = async (id, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_eo}/${id}${Constants.PATH.SALES.SALES_ORDER.removeAppointment}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoDeleteAttachmentPut = async (params, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.deleteAttachment}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      options,
      params,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoApprovePut = async (id, reason, remarks, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_so}/${id}${Constants.PATH.SALES.SALES_ORDER.approve}`;
  try {
    const params = { reason };
    if (remarks) {
      params.remarks = remarks;
    }
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      options,
      params,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoFetchRemarksGet = async (so_type, brand_name, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.fetchRemarks}`;
  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { so_type, brand_name},
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoRejectPut = async (id, reason, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_so}/${id}${Constants.PATH.SALES.SALES_ORDER.reject}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      options,
      params: { reason },
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoSendForApprovalPut = async (id, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_so}/${id}${Constants.PATH.SALES.SALES_ORDER.sendForApproval}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const roIdExcessSkuFileGet = async (id, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_ro}/${id}/excess-sku-file`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const v1SiSoShortQtyCreditNoteCancelPut = async (soId, remark, reason, options) => {
  const resourcePath = `${Constants.PATH.SALES.SALES_ORDER.si_so}/${soId}${Constants.PATH.SALES.SALES_ORDER.shortQtyCreditNoteCancel}`;
  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      params: { remark, reason },
      options,
      isSI
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

export {
  v1SiSoSkuValidatePost,
  v1SiSoDeleteSkuPut,
  v1SiSoOptionsGet,
  v1SiSoCreateManualPost,
  v1SiSoDetailsGet,
  v1SiSoDownloadSkuListGet,
  v1SiSoCancelPut,
  v1SiSoListGet,
  v1SiSoSummaryGet,
  v1SiSoFiltersGet,
  v1SiSoSkuSubmitPost,
  v1SiSoCreatePost,
  v1SiSoUploadReceiptsPut,
  v1SiSoEditPut,
  v1SiSoPackValidatePost,
  v1SiSoPackSubmitPost,
  v1SiSoPackSampleGet,
  v1SiSoGenerateProformaInvoiceGet,
  v1SiSoMarkAsOpenPost,
  v1SiSoSampleGet,
  v1SiSoClearTaxTaxInvoicePreGeneratePost,
  v1SiSoAddAppointmentPost,
  v1SiSoEditAppointmentPost,
  v1SiSoUploadEpodPost,
  v1SiSoEpodManualUploadPost,
  v1SiSoEpodCancelPut,
  v1SiSoCancelAppointmentPost,
  v1SiEoAddAppointmentPost,
  v1SiEoEditAppointmentPost,
  v1SiEoCancelAppointmentPost,
  v1SiSoDeleteAttachmentPut,
  v1SiSoApprovePut,
  v1SiSoFetchRemarksGet,
  v1SiSoRejectPut,
  v1SiSoSendForApprovalPut,
  v1SiSoPackingDetailsValidatePost,
  v1SiSoPackingDetailsSubmitPost,
  v1SiSoPackingDetailsSampleGet,
  v1SiSoInventoryValidationPost,
  v1SiSoEoFiltersGet,
  v1SiEoListGet,
  v1SiEoSummaryGet,
  v1SiEoSkuValidatePost,
  roIdExcessSkuFileGet,
  v1SiSoShortQtyCreditNoteCancelPut
};
